import { Typography } from 'components/generic/typography';
import styled from 'styled-components';
import { em } from 'modules/helpers/style';
import { ColorNeutralDarkGrey, Spacing12 } from 'autogen/design-tokens/tokens';
import { SectionInfo } from '../shared/types';

const StyledBody = styled(Typography.Body)`
    display: block;
    text-transform: uppercase;
    letter-spacing: ${em(1.4, 16)};
    color: ${ColorNeutralDarkGrey};

    &:after {
        content: '';
        background-color: currentColor;
        display: block;
        height: ${em(2, 16)};
        width: ${em(55, 16)};
        margin-top: ${Spacing12};
    }
`;

export default function SectionName({ sectionInfo, ...restProps }: { sectionInfo: SectionInfo }) {
    const { name } = sectionInfo;

    return (
        <StyledBody forwardedAs="span" size="M" strong {...restProps}>
            {name}
        </StyledBody>
    );
}
